import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetTheBlacklistRetrieveActions,
  SetTheBlacklistEditsActions,
} from "../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import "../../../StyleSheet/MainComponent/REInvesment/ReInvesment.scss";
import { data } from "jquery";

const BlacklistApprove = (props) => {
  const { currentPage, setShow, show, EditId, data, selectVal, white_collar , to_dates , from_dates , search} = props;
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
   const form_data = new FormData()
  const initialState = {
    status: "",

    user_id: "",

    user_name: "",
    description: "",
    reason_type: "",
  };
  const [Data, setDatas] = useState(initialState);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  useEffect(() => {
    dispatch(SetTheBlacklistRetrieveActions({ EditId }));
  }, []);
  console.log(state.BlacklistRetrieveCall, "BlacklistRetrieveCall");
  useEffect(() => {
    /// console.log(state.BlacklistRetrieveCall.Blacklistdataretrieve, "datas");
    if (
      state.BlacklistRetrieveCall != undefined &&
      state.BlacklistRetrieveCall.Blacklistdataretrieve.id != undefined
    ) {
      const dateString =
        state.BlacklistRetrieveCall.Blacklistdataretrieve.applied_date;
      const dateObject = new Date(dateString);
      const hours = dateObject.getHours();
      const minutes = dateObject.getMinutes();
      const amOrPm = hours >= 12 ? "PM" : "AM";
      const twelveHourFormat = hours % 12 || 12;
      const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

      setDatas({
        ...Data,
        status: state.BlacklistRetrieveCall.Blacklistdataretrieve.status,
        user_name:
          state.BlacklistRetrieveCall.Blacklistdataretrieve.user_id.first_name,
        reason_type: state.BlacklistRetrieveCall.Blacklistdataretrieve.reason,
        description:
          state.BlacklistRetrieveCall.Blacklistdataretrieve.reason_for_decline,
      });
    }
  }, [state.BlacklistRetrieveCall]);
  const HandleChanges = (e) => {
    setDatas({
      ...Data,
      status: e.target.value,
    });
  };
  const HandleDecriptions = (e) => {
    setDatas({
      ...Data,
      description: e.target.value,
    });
  };

  const handleClose = () => {
    setShow(false);
  };
  const HandleClick = () => {
    form_data.append("data",JSON.stringify({
        status: Data.status.toLowerCase(),
      description:
        Data.status.toLowerCase() == "decline" ? Data.description : "",
    }))

    const payload = {
      status: Data.status.toLowerCase(),
      description:
        Data.status.toLowerCase() == "decline" ? Data.description : "",
      //description: Data.description,
      EditId: EditId,
      currentPage: currentPage,
      data: data,
      selectVal: selectVal,
      form_data:{
        status: Data.status.toLowerCase(),
      description:
        Data.status.toLowerCase() == "decline" ? Data.description : ""
      },
      count:1 , 
      white_collar:white_collar, 
      // month: Datestate.month,
      // year: Datestate.year,
      // date:Datestate.date , 
      to_dates:to_dates , 
      from_dates:from_dates
    };
    dispatch(SetTheBlacklistEditsActions(payload, props.setShow()));
  };
  const Options = [
    {
      id: 1,
      Status: "Approved",
    },
    {
      id: 2,
      Status: "Decline",
    },
    {
      id: 3,
      Status: "Pending",
    },
  ];
  return (
    <>
      <div className={`${stateDisplay ? " POPUP" : "outerPOPUP"}`}>
        <div className="col BodyContent LeaveEdits">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div className="ModalHeader">
                      <span>Block Request</span>
                      <div
                        className="CloseIcon"
                        onClick={(e) => setShow(false)}
                      >
                        <CloseOutlinedIcon />
                      </div>
                    </div>
                    <div className="Modal-Body Modal-bodyUserCRUD ">
                      <div className="row">
                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.user_name}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Reason
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="first_name"
                            value={Data.reason_type}
                            readOnly
                          />
                        </div>
                                                <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Status
                          </label>

                          <select
                            class="form-select form-select-lg col-12"
                            aria-label=".form-select-lg example"
                            onChange={HandleChanges}
                            /// value={Data.status}
                          >
                            {Options.map((item) => (
                              <option
                                selected={
                                  Data.status.toLowerCase() ==
                                  item.Status.toLowerCase()
                                }
                                value={item.Status}
                              >
                                {item.Status}
                              </option>
                            ))}
                          </select>
                        </div>
                        {Data.status.toLowerCase() == "decline" ? (
                          <>
                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Reason for decline
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                required
                                autocomplete="off"
                                name="description"
                                value={Data.description}
                                onChange={HandleDecriptions}
                              />
                            </div>
                          </>
                        ) : null}

                      </div>

                      <div className="row">
                        <div
                          className="row"
                          style={{ padding: "20px", marginLeft: "10px" }}
                        >
                          {state.BlacklistRetrieveCall != undefined &&
                          state.BlacklistRetrieveCall.Blacklistdataretrieve !=
                            null &&
                          state.BlacklistRetrieveCall.Blacklistdataretrieve
                            .documents ? (
                            <>
                              <label
                                for="validationCustom01"
                                class="form-label"
                              ></label>
                              <div className="col-sm-3 mt-3 BefoereImageView">
                                {state.BlacklistRetrieveCall
                                  .Blacklistdataretrieve != undefined &&
                                  state.BlacklistRetrieveCall.Blacklistdataretrieve.documents.map(
                                    (item, indes) => (
                                      <>
                                        <div className="ImagesList">
                                          <a
                                            onClick={(e) =>
                                              window.open(item.media_url)
                                            }
                                            target="blank"
                                            style={{ cursor: "pointer" }}
                                            download={item.media_url}
                                          >
                                            <img src={item.media_url} />
                                          </a>
                                        </div>
                                      </>
                                    )
                                  )}
                              </div>
                            </>
                          ) : null}
                        </div>
                      </div>


                    </div>

                    <div className="UserButtons">
                      <button
                        class="btn  SaveBtn"
                        type="submit"
                        onClick={(e) => {
                          HandleClick(e);
                        }}
                        disabled={
                          state.BlacklistRetrieveCall.Blacklistdataretrieve
                            .status == Data.status.toLowerCase()
                        }
                      >
                        Submit 
                      </button>
                      <button
                        class="btn CancelBtn"
                        onClick={(e) => handleClose(e)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlacklistApprove;
